<template>
  <div class="map-quiz">
    <event-message v-if="$store.state.event.status" />
    <event-map v-else />
  </div>
</template>

<script>
import EventMessage from '@/components/Map/Event/Message'
import EventMap from '@/components/Map/Event/Map'

export default {
  components: {
    EventMessage,
    EventMap
  },

  created: async function () {
    await this.$store.dispatch('event/fetchPlaying')
  }
}
</script>

<style lang="scss" scoped>
.map-quiz {
  @include caption-center-base;
}
</style>
